module.exports = __webpack_public_path__ + "img/fire-burner.3b1c6d93.png";